export const portalUrl: string = "https://tcx-portal-api.azurewebsites.net/api/user/verification";
export const apiKey: string = "213ed4c2-19d5-4b6c-ad2c-eb61af6b5451";
export const isMaintainentMode: boolean = false;
